import React, { useRef } from 'react';
import ErrorBoundary from 'src/components/error-boundary';
import { IProductPageTabsProps } from './types';
import {
  PropertiesTabContent,
  StatisticsTabContent,
  MainContent,
  ReviewsContent,
} from './styles';
import {
  ProductTabMain,
  ProductTabProperties,
  ProductTabReviews,
  ProductTabStatistics,
} from './sections';
import { useLocation } from 'react-router-dom';
import { delayedScrollIntoView } from './utils';
import {
  MainTabId,
  PropertiesTabId,
  ReviewsTabId,
  StatisticsTabId,
} from './constants';
import Lazy from '@prisjakt/ui-lazy';
import AdContainer from 'src/components/ads';
import { PageSection } from 'src/components/page';

const ProductTabs: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IProductPageTabsProps>
>> = props => {
  const { product, recommendations, currentCampaign } = props;
  const location = useLocation();
  const firstRender = useRef(true);

  if (!product) {
    return null;
  }

  if (
    location.hash !== '' &&
    location.hash !== '#main' &&
    firstRender.current
  ) {
    firstRender.current = false;
    const targetElement = document.getElementById(location.hash)!;
    delayedScrollIntoView(targetElement);
  }
  return (
    <>
      <MainContent id={MainTabId}>
        <ProductTabMain
          product={product}
          recommendations={recommendations}
          currentCampaign={currentCampaign}
        />
      </MainContent>

      <ReviewsContent id={ReviewsTabId}>
        <ErrorBoundary onError={returnNull}>
          <Lazy>
            <ProductTabReviews product={product} />
          </Lazy>
        </ErrorBoundary>
      </ReviewsContent>

      <StatisticsTabContent id={StatisticsTabId}>
        <PageSection noBorder noPad="bottom">
          <AdContainer
            placement="panorama_extra"
            format="panorama_1_wde"
            min={861}
            max={10000}
            scalable
            scaleBase=".pj-ui-panel--row"
            spacing={{
              top: '10px',
              bottom: '10px',
            }}
          />

          <AdContainer
            placement="dubbelpanorama1"
            format="panorama_1"
            min={0}
            max={860}
            spacing={{
              top: '10px',
              bottom: '10px',
            }}
          />
          <ErrorBoundary onError={returnNull}>
            <Lazy>
              <ProductTabStatistics product={product} />
            </Lazy>
          </ErrorBoundary>
        </PageSection>
      </StatisticsTabContent>

      <PropertiesTabContent id={PropertiesTabId}>
        <PageSection noBorder>
          <ErrorBoundary onError={returnNull}>
            <Lazy>
              <ProductTabProperties product={product} />
            </Lazy>
          </ErrorBoundary>
        </PageSection>
      </PropertiesTabContent>
    </>
  );
};

const returnNull = () => null;

export default ProductTabs;
